/* eslint-disable @typescript-eslint/no-explicit-any */
import {Dialog, DialogTitle, Box} from '@mui/material';
import {useEffect, useRef, useState} from 'react';

export const DialogBody = ({children, ...props}: any) => {
  const header = useRef<Element>();
  const footer = useRef<Element>();
  const [bodyHeight, setBodyHeight] = useState(700);

  useEffect(() => {
    setTimeout(() => {
      const _headerSize = header?.current?.clientHeight;
      const _footerSize = footer?.current?.clientHeight;

      if (_headerSize && _footerSize) {
        const _bodyHeight = window.innerHeight - _headerSize - _footerSize;
        setBodyHeight(_bodyHeight);
      }
    }, 1);
  });
  return (
    <Dialog fullScreen sx={{maxWidth: 1400}} open={props.open}>
      <DialogTitle sx={{p: 0}}>
        <Box ref={header}>{props.header}</Box>
      </DialogTitle>
      <Box
        sx={{
          // p: 3,
          maxHeight: bodyHeight,
          overflow: 'scroll',
          scrollbarWidth: 'none',
          // pb: `100px`,
          pt: 1,
          px: 1,
        }}
      >
        {children}
      </Box>
      <Box
        sx={{
          height: 'fit-content',
          position: 'absolute',
          bottom: '0',
          width: '100%',
        }}
        ref={footer}
      >
        {props.footer}
      </Box>
    </Dialog>
  );
};

export default DialogBody;
